import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';

import { ConfigService } from '../../../../../core';
import { ConfigCliente } from '../../../../configuracoes/app/cliente';
import { ConfigEmpresa } from '../../../../configuracoes/app/empresa';

interface Config {
    showCard: boolean;
}

@Component({
    selector: 'sgt-card-message-destaque-ipi',
    templateUrl: './card-message-destaque-ipi.component.html',
    styleUrls: ['./card-message-destaque-ipi.component.less']
})
export class CardMessageDestaqueIpiComponent implements OnInit, OnChanges {
    config: Config;
    configEmpresa: ConfigEmpresa;
    configCliente: ConfigCliente;
    @Input() isentoIpi: boolean;

    constructor(private configService: ConfigService) { }


    ngOnInit(): void {
        this.configEmpresa = this.configService.getEmpresa();
        this.configCliente = this.configService.getCliente();
        this.setConfig();
    }

    ngOnChanges(changes: SimpleChanges) {
        for (const propName in changes) {
            if (propName === 'isentoIpi') {
                this.setConfig();
            }
        }
    }

    private setConfig() {
        this.config = {
            showCard: this.isShowCard(),
        }
    }

    /** Verifica se deve exibir a mensagem de destaque do IPI */
    isShowCard(): boolean {
        // Se estiver configurado para não exibir a Isenção de IPI do cliente
        if (!this.configEmpresa?.aplicaIpi) {
            return false;
        }
        // Sem mensagem configurada
        if (!this.configCliente?.mensagemDestaqueIpi) {
            return false;
        }

        return !this.isentoIpi;
    }
}
